<template>
	<v-container fluid class="pa-4">
		<v-card class="background-2 round-card">
			<v-card-title class="pa-3">
				<v-icon left color="primary">mdi-newspaper-variant-outline</v-icon>
				<p>Storico Novità e Comunicazioni</p>
				<v-spacer></v-spacer>
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Cerca"
					clearable
					hide-details
					outlined
					dense
					class="mr-3"
					style="max-width: 300px"
				></v-text-field>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" @click="getReleases" :loading="loading">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
					</template>
					<span>Aggiorna</span>
				</v-tooltip>
			</v-card-title>
			<v-divider></v-divider>

			<v-data-iterator
				:items="releases"
				:options.sync="pagination"
				:server-items-length="totalItems"
				:loading="loading"
				:footer-props="{
					'items-per-page-options': [6, 12, 24, 48],
					showFirstLastPage: true
				}"
			>
				<template v-slot:loading>
					<v-row class="pa-4">
						<v-col cols="12" class="text-center">
							<v-progress-circular indeterminate color="primary"></v-progress-circular>
						</v-col>
					</v-row>
				</template>

				<template v-slot:no-data>
					<v-row class="pa-4">
						<v-col cols="12" class="text-center">
							<v-icon size="64" color="grey lighten-1">mdi-newspaper-variant-outline</v-icon>
							<div class="fs14i grey--text mt-3">Nessuna novità disponibile</div>
						</v-col>
					</v-row>
				</template>

				<template v-slot:default="{ items }">
					<v-row class="pa-3">
						<v-col
							v-for="release in items"
							:key="release.id"
							cols="12"
						>
							<v-card
								class="background-1 round-card h100p d-flex flex-column"
								outlined
								hover
								@click="openRelease(release)"
							>
								<v-card-title class="fs14i fw500 pb-2">
									<v-avatar size="36" class="primary mr-3">
										<v-icon color="white">mdi-new-box</v-icon>
									</v-avatar>
									<span class="string-cutter" style="flex: 1">{{ release.title }}</span>
								</v-card-title>
								<v-card-text class="fs12i flex-grow-1" style="max-height: 80px; overflow: hidden">
									<div v-html="truncateHtml(release.description, 300)"></div>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions class="pa-3">
									<v-chip small outlined color="primary">
										<v-icon left small>mdi-calendar</v-icon>
										{{ formatDate(release.created_at) }}
									</v-chip>
									<v-spacer></v-spacer>
									<v-btn text small color="primary" @click.stop="openRelease(release)">
										Leggi
										<v-icon right small>mdi-arrow-right</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
				</template>

				<template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
					Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
				</template>
			</v-data-iterator>
		</v-card>

		<v-dialog v-model="openReleaseDialog" width="900px">
			<v-card class="background-2 round-card">
				<v-card-title class="subtitle-1 background-2">
					<v-icon left color="primary">mdi-new-box</v-icon>
					{{ currentRelease.title }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4">
					<blockquote class="blockquote" v-html="currentRelease.description"></blockquote>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="openReleaseDialog = false">Chiudi</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
export default {
	name: 'releases-history',

	data() {
		return {
			releases: [],
			loading: false,
			search: '',
			pagination: { itemsPerPage: 12, page: 1 },
			totalItems: 0,
			openReleaseDialog: false,
			currentRelease: { title: '', description: '', expiration_date: '' },
			debounceTimer: null,
			initialized: false
		}
	},

	watch: {
		pagination: {
			handler() {
				if (this.initialized) {
					this.getReleases()
				}
			},
			deep: true
		},

		search: {
			handler() {
				if (this.debounceTimer) clearTimeout(this.debounceTimer)
				this.debounceTimer = setTimeout(() => {
					this.pagination.page = 1
					this.getReleases()
				}, 500)
			}
		}
	},

	mounted() {
		this.getReleases()
		this.$nextTick(() => {
			this.initialized = true
		})
	},

	methods: {
		getReleases() {
			this.loading = true

			const dataObject = {
				page: this.pagination.page,
				per_page: this.pagination.itemsPerPage,
				filter: this.search,
				sortBy: ['order', 'created_at'],
				sortDesc: [false, true]
			}

			this.axios.post('releases-history', dataObject).then(response => {
				this.releases = response.data.data.data
				this.totalItems = response.data.data.total
				this.loading = false
				this.$store.commit('endProgress')
			}).catch(() => {
				this.loading = false
				this.$store.commit('endProgress')
				this.$store.commit('setSnackbarError')
			})
		},

		openRelease(release) {
			this.currentRelease = release
			this.openReleaseDialog = true
		},

		formatDate(date) {
			if (!date) return ''
			const d = new Date(date)
			return d.toLocaleDateString('it-IT', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			})
		},

		truncateHtml(html, maxLength) {
			if (!html) return ''
			const text = html.replace(/<[^>]*>/g, '')
			if (text.length <= maxLength) return text
			return text.substring(0, maxLength) + '...'
		}
	}
}
</script>

<style scoped>
.h100p {
	height: 100%;
}
</style>
